export default "__VITE_ASSET__DeZb7pQN__"